// TelcoTrack - Theme Service
// Theme management with DOM manipulation

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private currentThemeSubject = new BehaviorSubject<string>('light');
  public currentTheme$ = this.currentThemeSubject.asObservable();

  constructor() {
    this.initializeTheme();
  }

  /**
   * Initialize theme
   */
  initializeTheme(): void {
    // Get saved theme from localStorage or default to light
    const savedTheme = localStorage.getItem('theme') || 'light';
    this.applyTheme(savedTheme);
    this.currentThemeSubject.next(savedTheme);
  }

  /**
   * Toggle theme
   */
  toggleTheme(): void {
    const current = this.currentThemeSubject.value;
    const newTheme = current === 'light' ? 'dark' : 'light';
    this.applyTheme(newTheme);
    this.currentThemeSubject.next(newTheme);
  }

  /**
   * Apply theme to DOM
   */
  private applyTheme(theme: string): void {
    // Save to localStorage
    localStorage.setItem('theme', theme);
    
    // Apply to document
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }
}